<template>
  <div class="AccountConfig">
    <el-main class="p-0">  
      <el-form ref="form"
        label-width="80px"
        class="form-label-80"
        :rules="rules"
        :model="data"
      >  
        <el-row>
          <el-col :span="8">
            <el-form-item label="대표계좌" prop="represent">
              <el-select v-model="data.represent">
                <el-option
                  v-for="item in items"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <span class="text-warning">
              계좌설정이 되지 않은 거래처에 적용되는 대표 계좌입니다.
            </span>
          </el-col>
        </el-row>    
        <el-row>
          <el-col :span="24">
            <el-form-item label="A/S계좌" prop="service">
              <el-select v-model="data.service">
                <el-option
                  v-for="item in items"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>    
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        @shortkey.native="handleClickSave"
        @click="handleClickSave"
      >{{ $t("button.save") }}(F4)</el-button>
    </el-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AccountConfig",
  data() {
    return {
      title: this.$t("title.account"),
      data: {},
      rules: {
        represent: [{ required: true, message: "대표계좌를 선택하세요" }],
        service: [{ required: true, message: "A/S계좌를 선택하세요" }],
      },
    }
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_config", "table_account"]),    
    items() {
      return this.table_account.filter(account => account.type_id === 2)
    },
  },
  mounted() {
    let item = this.table_config.find(c => c.key === 'account');
    this.data = item ? Object.assign({}, item.value) : {}
  },
  methods: {
    doSave() {
      let data ={
        key: 'account',
        value: this.data
      };
      this.api.updateConfig(data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, '저장되었습니다.');
      });
    },
    handleClickSave() {
      if (!this.has_grant_write) { return; }
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.doSave();
      });
    },
  },
}
</script>
